import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { Observable, startWith } from 'rxjs';
import { Store } from '../../store';
import { ProductSalesStats } from '../../../purchase/product-sales-stats';
import { PurchaseService } from '../../../purchase/purchase.service';
import { StoreService } from '../../store.service';
import { map, switchMap } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { Product } from '../../../product/product';

interface ProductSalesStatsDisplay extends ProductSalesStats {
  price: number;
}

@Component({
  selector: 'app-sales-stats',
  templateUrl: './sales-stats.component.html',
  styleUrls: ['./sales-stats.component.scss'],
})
export class SalesStatsComponent implements AfterViewInit {
  @Input() store: Store | undefined;
  @ViewChild('myPaginator') paginator: MatPaginator | undefined;
  displayedColumns: string[] = ['product', 'price', 'sales'];
  data: ProductSalesStatsDisplay[] = [];
  resultsLength = 0;
  readonly PAGE_SIZE = 16;

  constructor(
    private purchaseService: PurchaseService,
    private storeService: StoreService
  ) {}

  ngAfterViewInit(): void {
    this.paginator?.page
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.getData(this.paginator!.pageIndex, this.PAGE_SIZE);
        }),
        map((data) => {
          this.resultsLength = data.totalCount;
          return data.items;
        })
      )
      .subscribe((data) => {
        this.data = data;
      });
  }

  getData(
    pageIndex: number,
    pageSize: number
  ): Observable<{ totalCount: number; items: ProductSalesStatsDisplay[] }> {
    return this.storeService.getUserStoreProducts().pipe(
      switchMap((products: Product[]) =>
        this.purchaseService
          .getStorePurchasesStatsPaged(this.store?.id!, pageIndex + 1, pageSize)
          .pipe(
            map((res) => {
              const productSalesStats: ProductSalesStatsDisplay[] =
                res.product_sales_stats.map(
                  (stat): ProductSalesStatsDisplay => {
                    const product = products.find(
                      (product) => product.id === stat.product
                    );
                    return {
                      ...stat,
                      product: product?.name || 'N/A',
                      price: product?.price || 0,
                    };
                  }
                );
              return { totalCount: res.count, items: productSalesStats };
            })
          )
      )
    );
  }
}
